import {Text} from 'platform/foundation';
import {NumberFormatter} from 'platform/locale';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {formatVehiclesChangeLabel} from '../utils/formatVehiclesChangeLabel';

interface SalesLeagueVehiclesChangeProps extends RequiredTestIdProps {
  vehiclesSoldChange: number;
  formatNumber: NumberFormatter;
}

export function SalesLeagueVehiclesChange(props: SalesLeagueVehiclesChangeProps) {
  const changeLabel = formatVehiclesChangeLabel(props.vehiclesSoldChange, props.formatNumber);

  return (
    <Text
      size="small"
      align="right"
      color="secondary"
      noWrap
      data-testid={suffixTestId('vehiclesChange', props)}
    >
      {changeLabel}
    </Text>
  );
}
